import Drawable from './Drawable.js';
import { getOSM } from '../OverworldAnimation.js';
import { c } from '../setup.js';


export default class VerticalPositionControl extends Drawable {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            nextZ: this.nextZ,
            position: this.position,
        };
    }

    static deserialize(data) {
        return new VerticalPositionControl({
            nextZ: data.nextZ,
            position: data.position,
        });
    }

    constructor({ nextZ, position, OSM, GUI }) {
        super({ position, OSM, GUI });
        this.visible = true;
        this.width = 16;
        this.height = 16;
        this.xModifier = 0;
        this.yModifier = 0;
        this.nextZ = nextZ;
    }

    entered() {
        const playerPosition = getOSM().player.position;
        const didEnter =
            playerPosition.x === this.position.x &&
            playerPosition.y === this.position.y &&
            this.position.z === playerPosition.z;
        return didEnter;
    }

    draw() {
        if (this.nextZ === 0) {
            c.fillStyle = 'rgba(255, 0, 0, 0.6)';
        } else if (this.nextZ === 1) {
            c.fillStyle = 'rgba(0, 255, 0, 0.6)';
        } else if (this.nextZ === 2) {
            c.fillStyle = 'rgba(0, 0, 255, 0.6)';
        } else {
            c.fillStyle = 'rgba(255, 255, 255, 1)';
        }
        c.fillRect(
            this.position.x + this.xModifier,
            this.position.y + this.yModifier,
            this.width,
            this.height
        );
    }
}
